import { Navigate, Route, Routes } from 'react-router';
import { sections } from '../sections/registry';
import { HubShell } from './HubShell';
import { HomePage } from './HomePage';

/**
 * One layout route rendering the shell, `/` for the home page, one parent route per section with
 * one child route per its pages, and a redirect home for anything unmatched. Whether the current
 * user may actually see a given section is decided inside `HubShell`, not here — see its access
 * check.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<HubShell />}>
        <Route index element={<HomePage />} />

        {sections.map((section) => (
          <Route key={section.id} path={section.basePath}>
            {section.pages.map((page) => (
              <Route
                key={page.id}
                index={page.path === ''}
                path={page.path === '' ? undefined : page.path}
                element={page.element}
              />
            ))}
          </Route>
        ))}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
